import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { GroupedFormData, ReportFormRuleTemplate } from '@navstation-portal/reporting/data-model/ui';
import {
  DisplacementResponse,
  EngineMode,
  IReport,
  MeRpmPowerResponse,
  PortCallPurpose,
  TcRpmPowerResponse,
} from '@navstation-portal/reporting/data-model/vessel-report';
import { DropboxItem } from '@navstation-portal/shared/data-model/common';
import { VesselSpec } from '@navstation-portal/vessels/data-model/vessel';

export interface DeleteReportResponse {
  id: string;
  new_report_number: number;
}

export type EdnFileType = 'edn' | 'ednPos';

export interface ReportApiService {
  getCarryoverReport(vesselId: string, reportId?: string): Observable<unknown>;
  getFormFieldRules(): Observable<Record<string, GroupedFormData>>;
  getReportFormRuleTemplate(vesselId: string): Observable<ReportFormRuleTemplate>;
  getReport(vesselId: string, reportId: string): Observable<unknown>;
  saveReport(vesselId: string, report: unknown, reportId?: string, submitType?: string): Observable<unknown>;
  deleteReport(vesselId: string, reportId: string): Observable<DeleteReportResponse>;
  getTcRpmPower(
    vesselId: string,
    tcrpm1: number | undefined,
    tcrpm2: number | undefined,
    modes: EngineMode[] | undefined
  ): Observable<TcRpmPowerResponse>;
  getMeRpmPower(
    vesselId: string,
    merpm: number | undefined,
    modes: EngineMode[] | undefined
  ): Observable<MeRpmPowerResponse>;
  getDisplacement(vesselId: string, draught: number): Observable<DisplacementResponse>;
  uploadEdnFile(vesselId: string, reportId: string, ednType: EdnFileType, file: File): Observable<DropboxItem[]>;
  deleteEdnFile(
    vesselId: string,
    reportId: string,
    ednType: EdnFileType,
    dropboxUrl: string
  ): Observable<DropboxItem[]>;
  getPortCallPurposes(): Observable<PortCallPurpose[]>;
}

export interface ReportApiAdapter {
  convertFromAPI(report: unknown, vesselSpec: VesselSpec | undefined): IReport;
  convertFromAPISavedReport(report: unknown, vesselSpec: VesselSpec | undefined): IReport;
  convertToAPI(report: IReport): Record<string, unknown>;
}

export const REPORT_API_SERVICE = new InjectionToken<ReportApiService>('REPORT_API_SERVICE');

export const REPORT_API_ADAPTER = new InjectionToken<ReportApiAdapter>('REPORT_API_ADAPTER');
